import * as Yup from 'yup'
import { i18n } from '@fs/zion-locale'

export const validationSchema = Yup.object().shape({
  solrSearch: Yup.string()
    .required(i18n.t('place-learn-to-rank-page.validation.required.error', 'Search query is required'))
    .test(
      'min-non-whitespace',
      i18n.t(
        'place-learn-to-rank-page.validation.min-chars.error',
        'Must contain at least 2 non-whitespace characters'
      ),
      (value) => {
        if (!value) return false
        const nonWhitespaceChars = value.replaceAll(/\s/g, '').length
        return nonWhitespaceChars >= 2
      }
    ),
})
